import Api from '@/api'
import SolvingMocks from '@/mocks/solving.json'

export default {
    namespaced: true,
    state: {
        current: {
            index: 0,
            stage: 2
        },
        answer: null,
        questions: null
    },
    getters: {
        progress (state) {
            return {
                state: state.current.stage,
                length: state.questions ? state.questions.length : 0,
                current: state.current.index + 1
            }
        },
        questions (state) {
            return state.questions
        },
        question (state) {
            return state.questions && state.questions[state.current.index]
        },
        answer (state) {
            return state.answer
        }
    },
    actions: {
        async init ({dispatch}, {stage}) {
            await dispatch('fetch', {stage})
        },
        async fetch ({commit}, {stage}) {
            commit('current', {stage})

            if (stage === 'solving') {
                commit('questions', SolvingMocks.questions)
            } else {
                return Api.GET(`api/quest?page=1&stage=${stage}&per-page=1000`).then(res => {
                    commit('questions', res)
                })
            }
        },
        answer ({commit}, value) {
            commit('answer', value)
        },
        answers (store, answers) {
            return Api.POST(`api/multi-answer/add`, answers)
        },
        async sendAnswer ({dispatch, getters, state}, answer) {
            if (state.current.stage === 'solving') {
                await Api.POST(`api/solving`, {
                    stage: getters.question.id,
                    data: answer || state.answer
                })
            } else {
                await Api.POST(`api/answer/add`, {
                    quest: getters.question.id,
                    text: answer || state.answer
                })
            }
            await dispatch('next')
        },
        async next ({commit, state, dispatch}) {
            let index = state.current.index + 1

            if (state.questions[index]) {
                commit('current', {index})
            } else {
                commit('current', {index: 0})
                commit('questions', [])
                dispatch('testing/next', undefined, {root: true})
            }
        },
        skip ({commit, dispatch}) {
            commit('current', {index: 0})
            commit('questions', [])
            dispatch('testing/next', undefined, {root: true})
        },
        reset ({commit}) {
            commit('current', {
                index: 0,
                stage: 2
            })
        }
    },
    mutations: {
        answer (state, value = null) {
            state.answer = value
        },
        current (state, {index, stage}) {
            state.current.index = typeof index === 'number' ? index : state.current.index
            state.current.stage = stage || state.current.stage
            state.answer = null
        },
        questions (state, data) {
            state.questions = data
        }
    }
}
